import { configureStore } from "@reduxjs/toolkit";
import IllnessReducer from "./illness/IllnessSlice";
import SpecialtiesReducer from "./illness/SpecialitiesSlice";
import doctorTableReducer from "./slices/DoctorTableSlice";
import doctorDateTimeReducer from "./slices/DoctorDateTimeSlice";
import searchPatientDataReducer from "./slices/SearchPatientSlice";
import appointmentChargeReducer from "./slices/appointmentChargeSlice";
import appointmentReducer from "./slices/appointmentSlice";
import billReducer from "./slices/billSlice";
import emailReducer from "./slices/emailSlice";
import careersFormReducer from './slices/careersSlice'
export const store = configureStore({
  reducer: {
    illness: IllnessReducer,
    specialize: SpecialtiesReducer,
    doctorTable: doctorTableReducer,
    doctorDateTime: doctorDateTimeReducer,
    searchPatientData: searchPatientDataReducer,
    appointmentCharge: appointmentChargeReducer,
    patientAppointment: appointmentReducer,
    bill: billReducer,
    email: emailReducer,
    careersForm:careersFormReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
